import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center pt-24">
      <div className="absolute inset-0 grid-bg opacity-25 mask-fade-b" />
      <div className="relative text-center px-6">
        <div className="font-mono-plex text-cyan-400 tracking-[0.3em] text-sm">ERROR 404</div>
        <h1 className="mt-4 font-display text-6xl md:text-8xl font-black tracking-tighter text-white">
          Page not <span className="text-gradient">found.</span>
        </h1>
        <p className="mt-5 text-slate-400 max-w-md mx-auto">
          The route you requested doesn't exist. Even our canary rollouts can't reach it.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-cyan-400 text-slate-950 font-semibold hover:bg-cyan-300 transition"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>
      </div>
    </section>
  );
}
